const main = document.getElementById('primary')
const setWidth = () => {
  const blocks = document.querySelectorAll('.boat-with-cta-block__field')
  if (blocks) {
    ;[...blocks].map((block) => {
      const gap = 30

      const boat = block.querySelector('.feed-boat-js')
      const container = block.querySelector('.container')
      const col = block.querySelector('.boat-with-cta-block__post-col')
      const mainWidth = main.clientWidth
      const containerWidth = container.clientWidth
      const colWidth = col.clientWidth
      const diff = (mainWidth - containerWidth) / 2
      const width = colWidth + diff

      if (window.matchMedia('(max-width: 991.98px)').matches) {
        boat.style.width = '100%'
      } else {
        boat.style.width = `${width - gap}px`
      }
    })
  }
}

setWidth()
window.addEventListener('load', setWidth)
window.addEventListener('resize', setWidth)
